import { Box, Flex, ListItem, UnorderedList } from '@chakra-ui/react';
import { useCarousel } from '~/hooks/useCarousel';
import React, { useLayoutEffect, useRef, useState } from 'react';
import CarouselChild from './CarouselChild';
import { makeIndices } from './utils';

var CarouselContainer = function CarouselContainer(props) {
  var _props$width;

  var children = props.children,
      _props$slidesPresente = props.slidesPresented,
      slidesPresented = _props$slidesPresente === void 0 ? 1 : _props$slidesPresente,
      interval = props.interval;

  var _useState = useState(undefined),
      containerWidth = _useState[0],
      setContainerWidth = _useState[1];

  var visibleSlideRef = useRef(null);
  var slides = React.Children.toArray(children);
  var length = slides.length;
  var numActive = Math.min(length, slidesPresented);

  var _useCarousel = useCarousel({
    interval: interval,
    length: length,
    options: {
      slidesPresented: numActive
    }
  }),
      active = _useCarousel[0],
      setActive = _useCarousel[1],
      handlers = _useCarousel[2],
      style = _useCarousel[3];

  var beforeIndices = makeIndices(slides.length - 1, -1, numActive);
  var afterIndices = makeIndices(0, +1, numActive);
  useLayoutEffect(function () {
    var _visibleSlideRef$curr, _visibleSlideRef$curr2;

    var slideWidth = visibleSlideRef === null || visibleSlideRef === void 0 ? void 0 : (_visibleSlideRef$curr = visibleSlideRef.current) === null || _visibleSlideRef$curr === void 0 ? void 0 : (_visibleSlideRef$curr2 = _visibleSlideRef$curr.getBoundingClientRect()) === null || _visibleSlideRef$curr2 === void 0 ? void 0 : _visibleSlideRef$curr2.width;
    setContainerWidth(slideWidth);
  }, []);

  var changeActiveSlideIndex = function changeActiveSlideIndex(event) {
    var _event$currentTarget$;

    setActive(parseInt((_event$currentTarget$ = event.currentTarget.dataset.itemId) !== null && _event$currentTarget$ !== void 0 ? _event$currentTarget$ : '', 10));
  };

  return length > 0 ? /*#__PURE__*/React.createElement(Box, {
    className: "carousel-container",
    position: "relative",
    overflow: "hidden",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : containerWidth
  }, /*#__PURE__*/React.createElement(Flex, Object.assign({
    overflow: "hidden",
    position: "relative"
  }, length > 1 ? handlers : {}, {
    style: style
  }), beforeIndices.map(function (i) {
    return /*#__PURE__*/React.createElement(CarouselChild, {
      key: i
    }, slides[i]);
  }), slides.map(function (slide, index) {
    return /*#__PURE__*/React.createElement(CarouselChild, {
      ref: visibleSlideRef,
      key: index
    }, slide);
  }), afterIndices.map(function (i) {
    return /*#__PURE__*/React.createElement(CarouselChild, {
      key: i
    }, slides[i]);
  })), /*#__PURE__*/React.createElement(UnorderedList, {
    className: "carousel-slides",
    ml: 0,
    zIndex: 15,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    pl: 0,
    sx: {
      listStyleType: 'none'
    },
    mt: 6
  }, slides.map(function (_, index) {
    return /*#__PURE__*/React.createElement(ListItem // @ts-ignore
    , {
      onClick: changeActiveSlideIndex,
      key: index,
      height: "15px",
      "data-item-id": index,
      position: "relative",
      flex: "0 1 auto",
      width: "1.5rem",
      margin: "0.125em 0.3em",
      borderColor: "primary.500",
      borderStyle: "solid",
      borderWidth: "1px",
      bg: active === index ? 'primary.500' : 'transparent',
      cursor: active === index ? 'default' : 'pointer',
      sx: {
        listStyleType: 'none'
      }
    });
  }))) : null;
};

export default CarouselContainer;